import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OffcanvasSheetComponent } from '../../shared/offcanvas-sheet/offcanvas-sheet.component';
import { SingleSelectDropdownComponent } from '../../business-details/single-select-dropdown.component';

export type ConfigOffcanvasMode = 'user' | 'role' | 'category';

@Component({
  selector: 'app-config-item-offcanvas',
  standalone: true,
  imports: [CommonModule, FormsModule, OffcanvasSheetComponent, SingleSelectDropdownComponent],
  templateUrl: './config-item-offcanvas.component.html',
  styleUrls: ['../../shared/offcanvas-sheet/offcanvas-sheet.shared.css'],
})
export class ConfigItemOffcanvasComponent implements OnChanges {
  @Input() visible = false;
  @Input() mode: ConfigOffcanvasMode = 'user';
  @Input() item: any = null;
  @Input() roles: any[] = [];
  @Input() isEditing = false;

  @Output() closeCanvas = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  editData: any = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (this.visible && (changes['visible'] || changes['item'])) {
      this.editData = this.item ? { ...this.item } : {};
    }
  }

  get adminRoles(): any[] {
    return this.roles.filter(r => r.isAdmin);
  }

  get adminRoleOptions(): { value: string; label: string }[] {
    return this.adminRoles.map(r => ({ value: String(r.roleID), label: r.roleName }));
  }

  get selectedRoleValue(): string | null {
    return this.editData.roleID != null ? String(this.editData.roleID) : null;
  }

  onRoleSelected(val: string | null): void {
    this.editData.roleID = val != null ? Number(val) : null;
  }

  get title(): string {
    const verb = this.isEditing ? 'Edit' : 'Add';
    switch (this.mode) {
      case 'user':     return `${verb} User`;
      case 'role':     return `${verb} Role`;
      case 'category': return `${verb} Category`;
    }
  }

  onSave(): void {
    this.save.emit({ ...this.editData });
    this.closeCanvas.emit();
  }

  onClose(): void {
    this.closeCanvas.emit();
  }
}
